import { gql } from '@apollo/client';
import SearchResultFragment from '@/components/common/UniversalSearch/apollo/SearchResult.fragment';
import SalesGptFragment from '@/components/common/UniversalSearch/apollo/SalesGpt.fragment';

const SearchFor = gql`
  ${SearchResultFragment}
  ${SalesGptFragment}

  query SearchFor(
    $query: String!
    $filterCategories: [SearchResultCategory!]
    $page: Int
    $perPage: Int
    $produceAiSummary: Boolean
  ) {
    search(
      query: $query
      filterCategories: $filterCategories
      page: $page
      perPage: $perPage
      produceAiSummary: $produceAiSummary
    ) {
      id
      salesGptQuery {
        sessionId
        summaryType
        summary
        flexCta
        wasExternalDataUsed
        wasCompanyPagesDataUsed
        sources(first: 8) {
          nodes {
            ...SalesGptFragment
          }
        }
      }
      results {
        category
        items {
          ...SearchResultFragment
        }
      }
    }
  }
`;

export default SearchFor;
